/**
 * 鼠标动作动画
 */
import fvAnimation from "./fvAnimation"
export default class fvMousescript extends fvAnimation {
    constructor(shape){
        super(shape,"fvMousescript");
        this.inFlag = 0;
        this.enterFunction = null;
        this.exitFunction = null;
        this.overFunction = null;
        this.moveFunction =  null;
        try {
            this.enterFunction = AsyncFunction(this.enterscript);
            this.exitFunction = AsyncFunction(this.exitscript);
            this.overFunction = AsyncFunction(this.overscript);
            this.moveFunction =  AsyncFunction(this.movescript); 
        } catch (error) {
            console.error(error);
            return;
        }
        
        this.overTimerFunction = function(){
            if(this.inFlag == 0) return;
            this.executionScript(this.overFunction);
            setTimeout(this.overTimerFunction,this.overTimer);
 
        }.bind(this);
    }

    run(event,value){
        if(value == false) return;
        if(this.inFlag == 0 && this.shape.mouseState){
            this.inFlag = 1;
            this.executionScript(this.enterFunction);
            this.executionScript(this.overTimerFunction);
        }else if(this.inFlag == 1 && !this.shape.mouseState){
            this.inFlag = 0;
            this.executionScript(this.exitFunction);
        }
        if(this.inFlag == 1 && "move" ===this.getEventType(event.type)){
            this.executionScript(this.moveFunction);
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/canvas/animation/fvMousescript.js